var CONFIG = {};

//  CONFIG.URL = 'http://localhost:3007';
// CONFIG.URL = "https://caredocument.casperon.co";
CONFIG.URL = 'https://www.caredaily.co.uk';


// //Recaptcha FOR LOCAL
// CONFIG.RECAPTCHA_SITE_KEY = '6LfW8DApAAAAABNvJzwShCq2JY_6AemJOXE4UklO';
// //
//Recaptcha FOR LIVE & STAGING
// CONFIG.RECAPTCHA_SITE_KEY = '6Ld0CDYpAAAAAHHgZBxq5i0mtGGf9-Wyj6TZoRTu';
CONFIG.GOOGLE_CLIENT_ID = '694610871722-0jj0j653mjm40d5vaes7dsao0uga91re.apps.googleusercontent.com';
CONFIG.RECAPTCHA_SITE_KEY = '6Ld0CDYpAAAAAHHgZBxq5i0mtGGf9-Wyj6TZoRTu';
//
export default CONFIG;